<template>
  <button
    class="registration-button"
    :class="{ 'registration-button--active': isActive }"
    @click.prevent="$emit('click')"
    @submit.prevent="$emit('click')"
  >
    <slot>{{ text }}</slot>
  </button>
</template>

<script>
export default {
  components: {},
  props: {
    text: String,
    isActive: Boolean,
  },
  emits: ['click'],
  data() {
    return {};
  },
  methods: {},
  computed: {},
  watch: {},
  // created: function() {}
};
</script>

<style scoped>
.registration-button {
  background: linear-gradient(-10deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2));
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 11px;
  color: white;
  font-size: 24px;
  padding: 0.75rem 2rem;
  /* height: 80px; */
  min-width: 120px;
  /* width: 30%; */
}
.registration-button--active {
  box-shadow: 0 0 6px 4px rgba(255, 255, 255, 0.5);
  border-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationButton.vue